import {
  baseServiceInvoiceSchema,
  BillingPeriod,
} from "@redotech/redo-billing-common/service-invoice";

import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export type ExchangeAgentInvoiceStatus = z.infer<
  typeof exchangeAgentInvoiceStatus
>;
export const exchangeAgentInvoiceStatus = z.object({
  period: createEnum(BillingPeriod),
  exchangesMade: z.number(),
  billingDueDate: z.date(),
  currentInvoiceAmount: z.number(),
});

export const getCurrentReturnAiExchangeAgentInvoice = {
  name: "getCurrentReturnAiExchangeAgentInvoice" as const,
  input: z.null(),
  output: exchangeAgentInvoiceStatus.nullable(),
};

export const getFinalizedReturnAiExchangeAgentInvoices = {
  name: "getFinalizedReturnAiExchangeAgentInvoices" as const,
  input: z.null(),
  output: z.array(baseServiceInvoiceSchema),
};
